<template>
  <div v-if="user">
    <div class="page-subtitle mt-5 mb-4">Sign In</div>
    <b-form-group
      id="input-group-email"
      label="Email Address"
      label-for="input-email"
      class="font-weight-bold"
    >
      <div class="input-link" @click="change('email')">
        <b-link>Change</b-link>
      </div>
      <b-form-input
        id="input-email"
        type="text"
        disabled
        v-model="user.email"
      ></b-form-input>
    </b-form-group>

    <b-form-group
      id="input-group-phone"
      label="Mobile Number"
      label-for="input-phone"
      class="font-weight-bold"
    >
      <div class="input-link" @click="change('phone_number')">
        <b-link>Change</b-link>
      </div>
      <b-form-input
        id="input-phone"
        type="text"
        disabled
        v-model="user.phone_number"
      ></b-form-input>
    </b-form-group>

    <b-form-group
      id="input-group-password"
      label="Password"
      label-for="input-password"
      class="font-weight-bold"
    >
      <div class="input-link" @click="change('password')">
        <b-link>Change</b-link>
      </div>
      <b-form-input
        id="input-password"
        type="password"
        disabled
        placeholder="••••••••••••••••"
        v-model="user.password"
      ></b-form-input>
    </b-form-group>
    <div class="page-subtitle mt-5 mb-4">Notifications</div>
    <div>
      <b-form-group>
        <b-form-checkbox
          switch
          size="lg"
          v-model="emailEnabled"
          @change="changeSetting('email_notification_enable', !emailEnabled)"
          ><label class="switch-label font-weight-bold"
            >Email notifications</label
          ></b-form-checkbox
        >
      </b-form-group>
    </div>
    <div class="page-subtitle mt-5 mb-4">Reminders</div>
    <div>
      <b-dropdown
        variant="outlined"
        :text="!reminderSetting ? 'Select Reminder' : reminderSetting"
        class="dropdown  m-2 gray--3"
      >
        <b-dropdown-item
          v-for="sched in scheduleList"
          :key="sched.id"
          :value="sched"
          class="align-middle"
          @click="changeSetting('expiring_schedule_id', sched.id)"
          >{{ sched.label }}</b-dropdown-item
        >
      </b-dropdown>
    </div>
    <b-alert
      class="custom-alert"
      :show="dismissCountDown"
      dismissible
      fade
      variant="primary"
      @dismiss-count-down="countDownChanged"
      >Notifications setting is successfully saved.</b-alert
    >
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations, mapGetters } from 'vuex'

export default {
  data() {
    return {
      dismissCountDown: 0,
      emailEnabled: false
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      scheduleList: state => state.notification.scheduleList
    }),
    ...mapGetters('notification', [
      'emailNotificationSetting',
      'reminderSetting'
    ])
  },
  watch: {
    emailNotificationSetting(value) {
      this.emailEnabled = value
    }
  },
  methods: {
    ...mapActions({
      getNotificationSettings: 'notification/getNotificationSettings',
      getScheduleList: 'notification/getScheduleList'
    }),
    ...mapMutations({
      setReminderSetting: 'notification/setReminderSetting',
      setEmailNotificationSetting: 'notification/setEmailNotificationSetting'
    }),
    change(field) {
      this.$router.push({
        name: 'user.verify-page',
        params: { field: field }
      })
    },
    async changeSetting(setting, value) {
      let formData = {
        [setting]: value
      }

      await this.$api
        .put(`notifications/settings`, formData)
        .then(({ data }) => {
          if (data.success) {
            this.setEmailNotificationSetting(
              data.data.email_notification_enable
            )
            this.setReminderSetting(data.data.expiring_schedule_id.label)
            this.showAlert()
          }
        })
    },
    showAlert() {
      this.dismissCountDown = 5
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    }
  },
  created() {
    this.getNotificationSettings()
    this.getScheduleList()
  }
}
</script>

<style lang="scss" scoped>
.form-control:disabled,
.form-control[readonly] {
  background-color: white;
}
.input-link {
  position: absolute;
  right: 23%;
  margin-top: 13px;
}
.switch-label {
  font-size: 16px;
  padding-left: 20px;
}
.dropdown {
  width: 100%;

  &:hover {
    border: 2px solid #4694ff;
    border-radius: 8px;
  }
}
/deep/ .dropdown-menu {
  width: 100%;
  border-radius: 8px;
  margin-top: 0;
  padding-top: 2px;
  padding-bottom: 0;
}
/deep/ .dropdown-toggle {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
/deep/ .dropdown-item {
  width: 100%;
  height: 52px;
  border-bottom: 2px solid #e5e5e5;
  display: flex;
  align-items: center;
}
</style>
